import FeedbackFormContainer from './Container/FeedbackContainer';
import FeedbackView from './View/Feedback';

export default FeedbackFormContainer;
export { FeedbackFormContainer, FeedbackView };
